import { Component, inject, OnInit } from '@angular/core';
import { BaryComponentHelper } from '../../../../shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ICustomer } from '../../../../../models/customer.model';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { UserTypology } from '../../../../../models/enums/user-typology.model';
import { PaymentPeriodEnum } from '../../../../../models/enums/payment-period.enum';

@Component({
  selector: 'jhi-modal-customer-user-typology',
  templateUrl: './modal-customer-user-typology.component.html',
  styleUrls: ['./modal-customer-user-typology.component.scss'],
})
export class ModalCustomerUserTypologyComponent implements OnInit {
  readonly #translateService = inject(TranslateService);
  readonly #modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public loaded = false;
  public customer!: ICustomer;
  public type!: UserTypology;

  public CASH = PaymentPeriodEnum.CASH;
  public OFFLINE = UserTypology.OFFLINE;
  public typologyOptions: any;

  public controls!: {
    userTypology: FormControl;
    paymentPeriod: FormControl;
    paymentDelay: FormControl;
  };

  public baryForm!: FormGroup;

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.#modalRef.hide();
  }

  public ngOnInit(): void {
    this.typologyOptions = [PaymentPeriodEnum.DAILY, PaymentPeriodEnum.WEEKLY, PaymentPeriodEnum.BIMONTHLY, PaymentPeriodEnum.MONTHLY].map(it => ({
      label: this.#translateService.instant('baryApp.PaymentPeriod.' + it),
      value: it,
    }));
    this.controls = {
      userTypology: new FormControl(this.type),
      paymentPeriod: new FormControl(this.customer.paymentPeriod ?? PaymentPeriodEnum.MONTHLY, [Validators.required]),
      paymentDelay: new FormControl(this.customer.paymentDelay ?? 30, [
        this.type === UserTypology.INIT_TRANSFERT_DEFERRED ? Validators.min(2) : Validators.min(0),
        Validators.max(300),
      ]),
    };
    this.baryForm = new FormGroup(this.controls);
    this.loaded = true;
  }

  public submit(): void {
    this.action.next(new BaryModalEvent({ submit: true }));
    this.#modalRef.hide();
  }

  public handleSubmit(): void {
    if (this.baryForm.invalid) {
      this.baryForm.markAllAsTouched();
    } else {
      this.action.next(new BaryModalEvent({ submit: true, value: this.baryForm.value }));
      this.#modalRef.hide();
    }
  }
}
